<div style="width:500px;">
  <div style="width:99%;">
    <span> <button class="btn btn border" (click)="saveSign()" [disabled]="!form.dirty">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-4">
          <label>
            Förkortning
          </label>
          <input id="abbreviation" type="text" class="form-control form-control-sm" formControlName="abbreviation">
        </div>
      </div>
      <div class="row">
        <div class="col-md-10">
          <label>
            Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label>
            Typ
          </label>
          <p-select *ngIf="types.length > 0" appendTo="body" [options]="types" formControlName="type" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setType($event)">
          </p-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label>
            Sorteringsordning
          </label>
          <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
        </div>
      </div>
    </form>
  </div>
</div>
